@let isRegular = size() === 'regular';
@let ref = reference();
@let unavailable = unavailableLabel();
@if (ref.type === AISharedReferenceType.ATTACHMENT) {
    <interacta-ai-shared-attachment-chip
        [attachment]="ref.attachment.attachmentData"
        [size]="size()"
        [unavailableLabel]="unavailable"
        (attachmentClick)="referenceClick.emit()"
    />
} @else {
    <button
        class="relative flex w-fit max-w-full items-center overflow-hidden bg-surface-B text-left after:absolute after:inset-0 after:content-[''] hover:after:bg-hovered-layer active:after:bg-pressed-layer"
        type="button"
        [matTooltip]="title()"
        [ngClass]="
            isRegular
                ? 'min-w-252 rounded-l-lg rounded-r-2xl pr-8'
                : 'min-w-168 rounded-lg pr-4'
        "
        (click)="referenceClick.emit()"
    >
        @if (
            ref.type === AISharedReferenceType.POST &&
                (ref.post
                    | apply: getCustomPostPreviewImage
                    | storageTemporaryLink$
                    | async);
            as coverSrc
        ) {
            <interacta-image
                alt=""
                class="shrink-0 overflow-hidden rounded-lg"
                [classes]="'object-cover size-full'"
                [ngClass]="isRegular ? 'size-84' : 'size-56'"
                [src]="coverSrc"
            />
        } @else {
            <span
                class="flex shrink-0 items-center justify-center rounded-lg"
                [class.bg-status-H]="isComment()"
                [ngClass]="isRegular ? 'size-84' : 'size-56'"
                [style.background]="postPlaceholderColor()"
            >
                <interacta-image
                    alt=""
                    [classes]="isRegular ? 'size-60' : 'size-40'"
                    [src]="thumbnailSrc()"
                />
            </span>
        }
        <span
            class="flex min-w-0 grow flex-col justify-center px-8 py-4"
            [ngClass]="isRegular ? 'typo-sm' : 'typo-xs'"
        >
            <span
                class="line-clamp-1 break-all"
                [class.typo-sm-bold]="isRegular"
                [class.typo-xs-bold]="!isRegular"
                >{{ title() }}</span
            >
            @if (unavailable) {
                <interacta-badge
                    class="mt-4 h-18! self-start px-4! typo-xs-bold text-text-on-status"
                    [bgColor]="'status-J'"
                    [rounded]="'small'"
                >
                    {{ unavailable | translate }}
                </interacta-badge>
            } @else if (isRegular) {
                @if (regularSubtitle(); as subtitle) {
                    <span
                        [ngClass]="
                            isComment()
                                ? 'line-clamp-2 wrap-break-word'
                                : 'truncate'
                        "
                        >{{ subtitle }}</span
                    >
                }
                @if (
                    ref.type === AISharedReferenceType.POST &&
                        ref.post.creationTimestamp;
                    as date
                ) {
                    <interacta-creation-date
                        class="text-text-mid-contrast"
                        [date]="date"
                    />
                }
            } @else if (smallSubtitle(); as subtitle) {
                <span class="truncate">{{ subtitle }}</span>
            }
        </span>
    </button>
}
